var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafari(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14c0 7.732-6.268 14-14 14-7.731 0-14-6.268-14-14C0 6.269 6.269 0 14 0c7.732 0 14 6.269 14 14z",
    fill: "#0277BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 14c0 6.958-5.642 12.6-12.6 12.6-6.958 0-12.6-5.642-12.6-12.6C1.4 7.042 7.042 1.4 14 1.4c6.958 0 12.6 5.642 12.6 12.6z",
    fill: "#81D4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 14c0 6.187-5.013 11.2-11.2 11.2-6.187 0-11.2-5.013-11.2-11.2C2.8 7.813 7.813 2.8 14 2.8c6.187 0 11.2 5.013 11.2 11.2z",
    fill: "#03A9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 20.3a.701.701 0 0 1-1.4 0 .701.701 0 0 1 1.4 0zM21 7.7a.701.701 0 0 1-1.4 0 .701.701 0 0 1 1.4 0zm-12.6 0a.701.701 0 0 1-1.4 0 .701.701 0 0 1 1.4 0zM21 20.3a.701.701 0 0 1-1.4 0 .701.701 0 0 1 1.4 0zM14 4.9l-1.05-2.8h2.1L14 4.9zm0 18.2 1.05 2.8h-2.1L14 23.1zm9.1-9.1 2.8-1.05v2.1L23.1 14zM4.9 14l-2.8 1.05v-2.1L4.9 14z",
    fill: "#81D4FA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "m18.9 9.1-6.3 3.5 2.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m9.1 18.9 6.3-3.5-2.8-2.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafari);
export default __webpack_public_path__ + "static/media/safari.6aa8af36.svg";
export { ForwardRef as ReactComponent };